import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../artikel/artikel.css";
import API_URL from "../../ApiUrl";
import axios from "axios";
import moment from "moment";

const ArtikelDetail = (props) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [artikelLain, setArtikelLain] = useState([]);
  const [artikelLainLoaded, setArtikelLainLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const slug = props.match.params.slug;
    fetchArtikelData(slug);
    fetchArtikelLain();
  }, [props.match.params.slug]);

  const fetchArtikelData = (slug) => {
    axios
      .get(`${API_URL.superStudent}/api/v1/application/website/artikel/${slug}`)
      .then((response) => {
        setData(response.data.data);
        setLoading(false);
        setError(null);
      })
      .catch((error) => {
        setLoading(false);
        setError("Gagal mengambil data artikel.");
        console.error("Error fetching artikel:", error);
      });
  };

  const fetchArtikelLain = () => {
    const slug = props.match.params.slug;
    axios
      .get(`${API_URL.superStudent}/api/v1/application/website/artikel`)
      .then((response) => {
        const allArtikel = response.data.data;
        const artikelDetail = allArtikel.find(
          (article) => article.slug === slug
        );
        const code_artikel_kategori = artikelDetail?.code_artikel_kategori;
        const filteredArtikel = allArtikel
          .filter(
            (article) =>
              article.code_artikel_kategori === code_artikel_kategori &&
              article.slug !== slug
          )
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          .slice(0, 5);

        setArtikelLain(filteredArtikel);
        setArtikelLainLoaded(true);
      })
      .catch((error) => {
        console.error("Data Tidak Masuk:", error);
      });
  };

  if (loading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  if (error) {
    return <div className="text-center py-5 text-danger">{error}</div>;
  }

  const highlightArticle = artikelLain.length > 0 ? artikelLain[0] : null;
  const listArticles = artikelLain.length > 1 ? artikelLain.slice(1) : [];

  return (
    <div className="artikel-page-wrapper">
      {/* Background Decorative Shapes */}
      <div className="artikel-bg-blob-1"></div>
      <div className="artikel-bg-blob-2"></div>
      <div className="artikel-bg-blob-3"></div>

      <div className="container artikel-content-container">
        {/* Top Header Row: Aligning Text and Sidebar Title */}
        <div className="row">
          <div className="col-lg-8 pe-lg-5 animate__animated animate__fadeInDown">
            <div className="detail-category-badge">
              {data.kategori?.kategori || "Umum"}
            </div>

            <h1 className="detail-main-title">
              {data.judul}
            </h1>

            <div className="detail-author-row">
              <div className="detail-author-avatar">NI</div>
              <div className="detail-author-info">
                <span className="detail-author-name">NIEC Indonesia</span>
                <span className="detail-author-date">
                  <i className="bi bi-clock"></i>
                  {moment(data.updated_at).format("DD MMMM YYYY")}
                </span>
              </div>
            </div>
          </div>

          <div className="col-lg-4 animate__animated animate__fadeInDown" style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '30px' }}>
            <h3 className="sidebar-section-title w-100 mb-0">Artikel Berkaitan</h3>
          </div>
        </div>

        {/* Content Row: Aligning Images */}
        <div className="row">
          {/* Main Content Column */}
          <div className="col-lg-8 pe-lg-5 animate__animated animate__fadeInLeft">
            <img
              src={data.image}
              className="detail-main-img"
              alt={data.judul}
            />

            <div
              className="detail-content"
              dangerouslySetInnerHTML={{ __html: data.isi }}
            />
          </div>

          {/* Sidebar / Related Articles Column */}
          <div className="col-lg-4 animate__animated animate__fadeInRight animate__delay-1s">
            {artikelLainLoaded && artikelLain.length > 0 ? (
              <>
                {/* Highlighted Related Article */}
                {highlightArticle && (
                  <Link to={`/artikeldetail/${highlightArticle.slug}`} className="related-card-highlight">
                    <img
                      src={highlightArticle.image}
                      className="related-highlight-img"
                      alt={highlightArticle.judul}
                    />
                    <div className="related-highlight-body">
                      <div className="badge-light-red">
                        {highlightArticle.kategori?.kategori || "Umum"}
                      </div>
                      <h4 className="related-highlight-title">
                        {highlightArticle.judul}
                      </h4>
                      <span className="related-date">
                        {moment(highlightArticle.updated_at).fromNow()}
                      </span>
                    </div>
                  </Link>
                )}

                {/* List Related Articles */}
                {listArticles.length > 0 && (
                  <div className="related-list-container">
                    {listArticles.map((article, index) => (
                      <Link to={`/artikeldetail/${article.slug}`} className="related-list-item" key={index}>
                        <img
                          src={article.image}
                          className="related-list-img"
                          alt={article.judul}
                        />
                        <div className="related-list-body">
                          <div className="badge-light-red" style={{ alignSelf: 'flex-start' }}>
                            {article.kategori?.kategori || "Umum"}
                          </div>
                          <h5 className="related-list-title">
                            {article.judul}
                          </h5>
                          <span className="related-date">
                            {moment(article.updated_at).fromNow()}
                          </span>
                        </div>
                      </Link>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <p className="text-muted">Tidak ada artikel yang berkaitan.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtikelDetail;
